import "../assets/cardTaskKanban.css";
import IconButton from "../../../common/components/IconButton.jsx"
import { FaTrash } from "react-icons/fa";

const TASK_TYPE_LABELS = {
  work: "Trabajo",
  training: "Capacitación",
  goal: "Meta",
};

function CardTaskKanban({ title, description, date, type, onClick, onDelete }) {
  const typeLabel = TASK_TYPE_LABELS[type] ?? type;
  const handleClick = e => {
    e.stopPropagation();
    onClick();
  }

  const handleDelete = e => {
    e.stopPropagation();
    onDelete();
  }

  return (
    <article className="card-task-kanban" style={{ position: 'relative' }} onClick={handleClick}>
      <h1>{title}</h1>
      <p>{description}</p>
      <footer>
        <p>{date}</p>
        <span className="card-task-type">{typeLabel}</span>
      </footer>
      <div style={{ position: 'absolute', top: 1, right: 1 }}>
        <IconButton onClick={handleDelete}>
          <FaTrash className="text-danger" />
        </IconButton>
      </div>
    </article>
  );
}
export default CardTaskKanban;


